module.exports = __webpack_public_path__ + "img/s7Model5.ba96a04a.webp";